/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProvinceResponseDto
 */
export interface ProvinceResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ProvinceResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProvinceResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ProvinceResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProvinceResponseDto
     */
    countryCode: string;
    /**
     * 
     * @type {Date}
     * @memberof ProvinceResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProvinceResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the ProvinceResponseDto interface.
 */
export function instanceOfProvinceResponseDto(value: object): value is ProvinceResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ProvinceResponseDtoFromJSON(json: any): ProvinceResponseDto {
    return ProvinceResponseDtoFromJSONTyped(json, false);
}

export function ProvinceResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProvinceResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'countryCode': json['countryCode'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ProvinceResponseDtoToJSON(json: any): ProvinceResponseDto {
    return ProvinceResponseDtoToJSONTyped(json, false);
}

export function ProvinceResponseDtoToJSONTyped(value?: ProvinceResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'countryCode': value['countryCode'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

